import { defineMessages } from 'react-intl'

export default defineMessages({
  retry: {
    id: 'pages.Error.retry',
    defaultMessage: 'Retry',
  },
  homepage: {
    id: 'pages.Error.Local.homepage',
    defaultMessage: 'Back to Home page',
  },
})
